import axios from "axios";
import authHeader from "./auth-header";

const serveradr = require('./IPadr.js').serveradr;

//*******************************************************************
//tohle prepsat *****************************************************
// const API_URL = "http://server.ipmdevelop.cz/api/test/";
const API_URL = "http://"+ serveradr + "/api/test/";


const getData = (id, y, m, d) => {
    // console.log('eeeeeee',id)
    return axios.get(API_URL + "get_data?id=" + id + "&y=" + y + "&m=" + m + "&d=" + d, { headers: authHeader() });
};

const getMonth = (id, y, m) => {
    console.log(y, m, 'click')
    return axios.get(API_URL + "get_month?id=" + id + "&y=" + y + "&m=" + m, { headers: authHeader() });
};


export default {
    getData,
    getMonth
};